import AirportGlobe from './AirportGlobe';

function App() {
  return <AirportGlobe />;
}

export default App;
